import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import masterService from './masterService';

const initialState = {
  loadedServices: {},
  dynamicLoadedServices: {},
  data: {},
  dynamicData: {},
  isLoading: false,
  isDynamicLoading: false,
  error: null
};

export const loadMasterData = createAsyncThunk(
  'master/loadMasterData',
  async (serviceKey, { getState, rejectWithValue }) => {
    const { master } = getState();
    if (master.loadedServices[serviceKey]) {
      return null;
    }
    try {
      const response = await masterService[serviceKey]();
      return {
        key: serviceKey,
        data: response
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || `Failed to load ${serviceKey}`);
    }
  }
);

export const loadDynamicMasterData = createAsyncThunk(
  'master/loadDynamicMasterData',
  async ({ serviceKey, params }, { getState, rejectWithValue }) => {
    const { master } = getState();
    const cacheKey = `${serviceKey}_${params}`;
    
    // Check if this exact service call is already cached
    if (master.dynamicLoadedServices[cacheKey]) {
      return null;
    }

    try {
      const response = await masterService[serviceKey](params);
      return {
        key: cacheKey,
        data: response
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || `Failed to load ${serviceKey}`);
    }
  }
);

const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Static master data cases
      .addCase(loadMasterData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loadMasterData.fulfilled, (state, action) => {
        if (action.payload) {
          state.data[action.payload.key] = action.payload.data;
          state.loadedServices[action.payload.key] = true;
        }
        state.isLoading = false;
      })
      .addCase(loadMasterData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // Dynamic master data cases
      .addCase(loadDynamicMasterData.pending, (state) => {
        state.isDynamicLoading = true;
        state.error = null;
      })
      .addCase(loadDynamicMasterData.fulfilled, (state, action) => {
        if (action.payload) {
          state.dynamicData[action.payload.key] = action.payload.data;
          state.dynamicLoadedServices[action.payload.key] = true;
        }
        state.isDynamicLoading = false;
      })
      .addCase(loadDynamicMasterData.rejected, (state, action) => {
        state.isDynamicLoading = false;
        state.error = action.payload;
      });
  }
});


export default masterSlice.reducer;